import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useHistory } from "react-router-dom";
import { getSavedDataFromDbIndex, save_from_database } from "../../lib/comm";
import {
  MainContext,
  STATUS_OFFLINE,
  STATUS_ONLINE,
  STATUS_ONLINE_NOCONNECTION,
  STATUS_SYNCED,
  UIContext,
  UpdateContext,
} from "../../main-context";
import Spinner from "./Spinner";

export default function OfflineBar() {
  const update_context = useContext(UpdateContext);
  const ui_context = useContext(UIContext);
  const history = useHistory();
  const main_context = useContext(MainContext);
  const [prev_saves, set_prev_saves] = useState(0);
  const [saving, set_saving] = useState(false);
  const saved_data = useMemo(() => {
    return main_context.saves.filter(
      (elem) => elem.id === main_context.status.id
    );
  }, [main_context.saves, main_context.status.id]);

  const process_saved_data = useCallback(async () => {
    set_saving(true);

    // serijsko snimanje podataka
    // for (const record of saved_data) {
    //   await save_from_database(
    //     record.url,
    //     record.data,
    //     record.timestamp,
    //     update_context
    //   );
    // }

    // paralelno snimanje podataka u chunkovima
    // for (let i = 1; i < 50; i++) {
    //   let round = saved_data.filter((x) => x.priority === i);
    //   let p = [];
    //   let current = 0;

    //   while (current < round.length) {
    //     const record = round[current];
    //     p.push(
    //       save_from_database(
    //         record.url,
    //         record.data,
    //         record.timestamp,
    //         update_context
    //       )
    //     );

    //     current++;
    //     if (current % 10 === 0) {
    //       await Promise.all(p);
    //       p = [];
    //     }
    //   }

    //   if (p.length) {
    //     await Promise.all(p);
    //     p = [];
    //   }
    // }

    // paralelno snimanje podataka odjednom
    const p = [];
    for (let i = 1; i < 50; i++) {
      let round = saved_data.filter((x) => x.priority === i);
      for (const record of round) {
        p.push(
          save_from_database(
            record.url,
            record.data,
            record.timestamp,
            update_context
          )
        );
      }

      await Promise.all(p);
    }

    set_saving(false);
  }, [saved_data, update_context]);

  useEffect(() => {
    function updateOnlineStatus() {
      if (!navigator.onLine) {
        update_context.update_ui_context((prev) => ({
          ...prev,
          online_status: STATUS_OFFLINE,
        }));
      } else {
        update_context.update_ui_context((prev) => ({
          ...prev,
          online_status: STATUS_ONLINE,
        }));
      }
    }

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);
    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, [update_context]);

  useEffect(() => {
    getSavedDataFromDbIndex(update_context);
  }, [update_context]);

  useEffect(() => {
    if (ui_context.online_status === STATUS_ONLINE) {
      if (!saving) {
        process_saved_data();
      }
    }
  }, [process_saved_data, saving, ui_context.online_status]);

  useEffect(() => {
    let handle;
    if (prev_saves === 1 && !main_context.saves.length) {
      const status = ui_context.online_status;
      update_context.update_ui_context((prev) => ({
        ...prev,
        online_status: STATUS_SYNCED,
      }));

      handle = window.setTimeout(() => {
        update_context.update_ui_context((prev) => ({
          ...prev,
          online_status: status,
        }));
      }, 3000);

      // RELOAD
      history.push("/");
      history.goBack();
    }
    set_prev_saves(main_context.saves.length);
    return () => {
      if (handle) {
        window.clearTimeout(handle);
      }
    };
  }, [
    history,
    main_context.saves.length,
    prev_saves,
    ui_context.online_status,
    update_context,
  ]);

  return (
    <>
      <div
        style={{
          textAlign: "center",
          backgroundColor:
            ui_context.online_status === STATUS_SYNCED ||
            ui_context.online_status === STATUS_ONLINE
              ? "green"
              : "red",
          color: "white",
          overflow: "hidden",
          fontSize: "20px",
          fontWeight: "bold",
          transition: "max-height 0.5s ease-in-out",
          maxHeight:
            ui_context.online_status === STATUS_ONLINE && !saved_data.length
              ? "0"
              : "28px",
        }}
      >
        Connection:{" "}
        {ui_context.online_status === STATUS_ONLINE
          ? "ONLINE"
          : ui_context.online_status === STATUS_ONLINE_NOCONNECTION
          ? "ONLINE - NO INTERNET CONNECTION"
          : ui_context.online_status === STATUS_SYNCED
          ? "DATA SYNC COMPLETE!"
          : "OFFLINE"}
        &nbsp;&nbsp;&nbsp; Queued Checks:{" " + saved_data.length}
        {!!main_context.saves.length &&
          ui_context.online_status === STATUS_ONLINE && (
            <span style={{ position: "relative", marginLeft: "30px" }}>
              <Spinner color="#fff"></Spinner>
            </span>
          )}
      </div>
    </>
  );
}
